import $ from 'jquery';
import { Errors } from "./util/errors";
import { Webdav } from "./util/webdav";
import { Wireup, ToggleValue, ShowIf, ReadonlyIf, ListView, FormValidation } from 'rustig';
import { ClearInputs } from "./util/clearinputs";
import { ColumnChart } from "./util/charts/columnchart";
import { LineChart } from "./util/charts/linechart";
import { AddressLoaderCounty } from './util/addressloadercounty';
import { CustomElements } from './util/customelements';
import { CheckboxGroup } from './util/checkboxgroup';
import { ShowIfHasValue } from './util/showifhasvalue';
import { HideIfHasValue } from './util/hideifhasvalue';
import { PostingPeriodField } from './util/postingperiodfield';
import { TagSearch } from './util/tagsearch';
import { TagSearchValidationHandler } from './util/formvalidation/tagsearchvalidationhandler';
import { HandlesItemRefresh } from './util/handlesItemRefresh';

declare global {
  interface Window {
    Cp: any;
    Webdav: Webdav;
    Rustig: any;
    HandlesItemRefresh: HandlesItemRefresh;
    GoogleMapId: string | null;
  }
}

$(function () {
  var app = new Wireup();
  CustomElements.register();

  app.push(ColumnChart.wireup, function () {
    $(this).each(function () {
      ColumnChart.load(this);
    });
  });
  app.push(LineChart.wireup, function () {
    $(this).each(function () {
      LineChart.load(this);
    });
  });

  app.push(PostingPeriodField.wireup, function () {
    $(this).each(function () {
      PostingPeriodField.load(this);
    });
  });
  app.push(TagSearch.wireup, function () {
    $(this).each(function () {
      TagSearch.load(this);
    });
  });

  app.execute();

  ClearInputs.Wireup();
  ToggleValue.wireupDocument();
  
  CheckboxGroup.wireup();
  ShowIfHasValue.wireup();
  HideIfHasValue.wireup();
  $(document).on('actualClick', (e) => $(<any>e.target)[0].click());
  FormValidation.registerHandler(new TagSearchValidationHandler());

  window.Cp = window.Cp || {};

  window.Cp.Errors = Errors;
  window.Webdav = Webdav;
  window.Rustig.ListView = ListView;
  window.HandlesItemRefresh = HandlesItemRefresh;
});
